import { NewsRepository } from 'common/repositories/index';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import Util from 'common/services/util/-RFC.util';

const _serviceDependencies = ['$scope', '$state', '$http', '$stateParams'];

/**
 * @ngdoc service
 * @name controllers.News
 *
 * @description
 * News controller
 */

let _$scope;
let _$state;
let _$http;
let _NewsRepository;
let languages = {};
const lang = CWCONFIG.language;
let parsedBookmarks;
const callUrl = CWCONFIG.news.getUrl;
const pagesNumber = CWCONFIG.news.numberOfPages;
const numberOfArticles = CWCONFIG.news.articlesOnPage;
let _Util;

class News {

    constructor($scope, $state, $http, $stateParams) {

        languages = {
            en: {
                threats: 2,
                'how-to': 2282,
            },
            de: {
                threats: 2,
                'how-to': 1214,
            },
            fr: {
                threats: 2,
                'how-to': 2300,
            },
            es: {
                threats: 2,
                'how-to': 6858,
            },
            it: {
                threats: 2,
                'how-to': 2300,
            },
            'pt-br': {
                threats: 2,
                'how-to': 6858,
            },
        };

        /**
         * Set default category
         */
        const availableCategory = 'how-to';

        /**
         * Check if blog is avalable
         */
        if (!languages[lang]) {

            $state.go('root.dashboard.home');
            return false;

        }

        /**
         * Check if language was changed
         */
        if (localStorage.getItem('news_language')) {

            if (lang !== localStorage.getItem('news_language')) {

                $state.go('root.dashboard.news', {
                    tab: availableCategory,
                    page: '1',
                });

            }

        }

        /**
         * Check if are missing params
         */
        if (!$state.params.tab || !$stateParams.page) {

            $state.go('root.dashboard.news', {
                tab: availableCategory,
                page: '1',
            });
            return false;

        }

        /**
         * Check if page is valid
         */
        if ($stateParams.page) {

            if (!Number.isInteger(parseInt($stateParams.page, 0))
                || parseInt($stateParams.page, 0) > pagesNumber) {

                $state.go('root.dashboard.news', {
                    tab: availableCategory,
                    page: '1',
                });
                return false;

            }

        }

        /**
         * Check if tab is valid
         */
        if ($state.params.tab) {

            if ($state.params.tab !== 'how-to'
                && $state.params.tab !== 'threats'
                && $state.params.tab !== 'bookmarks') {

                $state.go('root.dashboard.news', {
                    tab: availableCategory,
                    page: '1',
                });
                return false;

            }

        }

        /**
         * Check if blog language was updated
         */

        if (localStorage.getItem('news_language')) {

            if (lang !== localStorage.getItem('news_language')) {

                localStorage.setItem('news_language', lang);

            }

        } else {

            localStorage.setItem('news_language', lang);

        }

        _$http = $http;
        _$scope = $scope;
        _$state = $state;
        _NewsRepository = NewsRepository;
        _Util = Util;

        this.checkIfcategoryIsAvailable(languages[lang], $state.params.tab, _$state);

        _$scope.currentCategory = $state.params.tab;

        _$scope.categories = ['threats', 'how-to'];

        _$scope.currentPage = $stateParams.page;
        _$scope.bookmarks = _NewsRepository.getAllBookmarks();
        const newsList = _NewsRepository.getAll();
        _$scope.isLoading = true;
        _$scope.currentPages = _NewsRepository.getPageNumber();
        _$scope.availableCategories = languages[lang];
        _$scope.currentLanguage = lang;

        _NewsRepository.updateCurrentPage($state.params.tab, $stateParams.page);
        parsedBookmarks = JSON.parse(localStorage.getItem('bookmarks'));

        if (_$scope.bookmarks) {

            _$scope.isLoading = false;

        }

        if (parsedBookmarks) {

            this.getSavedArticles();

            if (parsedBookmarks[lang].length === 0) {

                _$scope.isLoading = false;

            }

        } else {

            this.initBookmarks();
            _$scope.isLoading = false;

        }

        let url = '';
        const categoryId = languages[lang][_$scope.currentCategory];

        url = `${callUrl}?categories=${categoryId}&page=${_$scope.currentPage}&per_page=${numberOfArticles}&_embed&lang=${lang}`;

        if (!newsList.length || newsList[$stateParams.page - 1] === null) {

            _NewsRepository.setPages(pagesNumber);

            if (_$scope.currentCategory === 'how-to' || _$scope.currentCategory === 'threats') {

                _$http({

                    method: 'GET',
                    url: `${url}`,

                }).then((response) => {

                    if (Array.isArray(response.data)) {

                        this.getShortDescription(response.data);
                        this.formatDate(response.data);
                        this.setBookmarkStatus(response.data);
                        this.updateBookmarkStatus(response.data);
                        this.checkLoadingStatus(_$scope.currentPage);
                        this.updateImagePath(response.data);

                        _NewsRepository
                            .replace(response.data, _$scope.currentPage, _$scope.currentCategory);

                    }
                    setTimeout(() => {

                        this.getAllArticles();
                        this.getSavedArticles();

                    }, 200);

                });

            }


        } else {

            _$scope.isLoading = false;

        }

        _$scope.news = _NewsRepository.getAll();

        if (newsList.length) {

            this.checkBookmarksStatus();

        }

        if (_$scope.currentCategory === 'how-to' || _$scope.currentCategory === 'threats') {

            this.checkLoadingStatus(_$scope.currentPage);

        }

        Mixpanel.send('ConnectWeb News Open', {
            Tab: $state.params.tab,
        });

    }

    /**
     * After first page is loaded,
     * this function makes async calls to get the rest of the pages
     */
    getAllArticles() {

        _$scope.news.forEach((item, index) => {

            const pageNumber = index + 1;

            _$scope.categories.forEach((category) => {

                let url = '';

                const categoryId = languages[lang][category];

                if (Object.prototype.hasOwnProperty.call(languages[lang], category)) {

                    url = `${callUrl}?categories=${categoryId}&page=${pageNumber}&per_page=${numberOfArticles}&_embed&lang=${lang}`;


                    if (!_$scope.news[index] || !_$scope.news[index][category].length) {

                        _$http({

                            method: 'GET',
                            url: `${url}`,

                        }).then((response) => {

                            if (Array.isArray(response.data)) {

                                this.getShortDescription(response.data);
                                this.formatDate(response.data);
                                this.setBookmarkStatus(response.data);
                                this.updateBookmarkStatus(response.data);
                                this.checkLoadingStatus(_$scope.currentPage);
                                this.updateImagePath(response.data);
                                _NewsRepository.replace(response.data, pageNumber, category);

                            }

                        });

                    }

                }

            });

        });

    }

    /**
     * Update short desciption for each article
     * Split by first 200 characters
     * param @array
     */
    getShortDescription(data) {

        data.forEach((item) => {

            const string = item.excerpt.rendered
                .split('</p>')[0].replace(/(<([^>]+)>)/ig, '').substr(0, 200);
            item.shortDescription = `${string}...`;

        });

    }

    /**
     * Update image source path
     * param @array
     */
    updateImagePath(data) {

        data.forEach((item) => {

            const thumbnailURL = _Util.deepFind(item, '_embedded.wp:featuredmedia.0.media_details.sizes.thumbnail.source_url');
            const articleListingURL = _Util.deepFind(item, '_embedded.wp:featuredmedia.0.media_details.sizes.article-medium-listing-thumbnail-1x.source_url');

            if (thumbnailURL) {

                item.image = thumbnailURL;

            } else if (articleListingURL) {

                item.image = articleListingURL;

            }

        });

    }

    /**
     * Update article date by removing the time
     */
    formatDate(data) {

        data.forEach((item) => {

            const date = item.date.split('T');
            [item.date] = date;

        });

    }

    /**
     * Update short desciption for a single article
     * Split by first 200 characters
     * param @object
     */
    getShortDescriptionSingleArticle(data) {

        const string = data.excerpt.rendered
            .split('</p>')[0].replace(/(<([^>]+)>)/ig, '').substr(0, 200);
        data.shortDescription = `${string}...`;

    }

    /**
     * Adding the bookmark status position for each article
     * default = false
     * param @array
     */
    setBookmarkStatus(data) {

        data.forEach((item) => {

            item.bookmarkStatus = false;

        });

    }


    /**
     * Updating the bookmark status for each article
     * This function is parsing each id saved in local storage
     * param @array
     */
    updateBookmarkStatus(data) {

        data.forEach((article) => {

            if (JSON.parse(localStorage.getItem('bookmarks'))[lang] !== null || JSON.parse(localStorage.getItem('bookmarks'))[lang].length > 0) {

                JSON.parse(localStorage.getItem('bookmarks'))[lang].forEach((item) => {

                    if (article.id === item) {

                        article.bookmarkStatus = true;

                    }

                });

            }

        });

    }

    /**
     * Setting local storage object with four positions: en, de, fr, it;
     * default = null
     */
    initBookmarks() {

        if (parsedBookmarks === null) {

            const bookmarks = {};

            Object.keys(languages).forEach((language) => {

                bookmarks[language] = [];

            });

            localStorage.setItem('bookmarks', JSON.stringify(bookmarks));
            parsedBookmarks = JSON.parse(localStorage.getItem('bookmarks'));

        }

    }

    /**
     * Adding the article id in bookmarks object
     * Setting the article bookmark status to true
     * params @string @string @int @string
     */
    saveArticle(articleId, thisBookmarkStatus, page, category) {

        if (thisBookmarkStatus === false) {

            const articlePosition = _$scope.news[page][category]
                .find(element => element.id === articleId);

            parsedBookmarks[lang].push(articleId);
            localStorage.setItem('bookmarks', JSON.stringify(parsedBookmarks));
            articlePosition.bookmarkStatus = true;

            this.getSavedArticle(articleId, lang);

            Mixpanel.send('ConnectWeb News Bookmark Click', {
                Bookmark: 'Save',
            });

        }

    }

    /**
     * Removing the article id from bookmarks object
     * Setting the article bookmark status to false
     * params @string @string @int @string
     */
    removeArticle(articleId, bookmarkStatus, page, category) {

        if (bookmarkStatus === true) {

            const articlePosition = _$scope.news[page][category]
                .find(element => element.id === articleId);

            parsedBookmarks[lang].forEach((localStorageItem) => {

                if (localStorageItem === articleId) {

                    const remove = function remove(array, element) {

                        return array.filter(el => el !== element);

                    };

                    parsedBookmarks[lang] = remove(parsedBookmarks[lang], localStorageItem);
                    localStorage.setItem('bookmarks', JSON.stringify(parsedBookmarks));
                    articlePosition.bookmarkStatus = false;
                    _NewsRepository.deleteBookmark(articleId, lang);

                }

            });

            Mixpanel.send('ConnectWeb News Bookmark Click', {
                Bookmark: 'Unsave',
            });

        }

    }

    /**
     * Removing the article id from bookmarks object
     * Setting the article bookmark status to false
     * params @int
     */
    removeArticleBookmarksTab(articleId) {

        parsedBookmarks[lang].forEach((localStorageItem) => {

            if (localStorageItem === articleId) {

                const remove = function remove(array, element) {

                    return array.filter(el => el !== element);

                };

                parsedBookmarks[lang] = remove(parsedBookmarks[lang], localStorageItem);
                localStorage.setItem('bookmarks', JSON.stringify(parsedBookmarks));
                _NewsRepository.deleteBookmark(articleId, lang);
                _$scope.bookmarks = _NewsRepository.getAllBookmarks();

            }

        });

        _$scope.news.forEach((item) => {

            if (item !== null) {

                Object.keys(item).forEach((category) => {

                    item[category].forEach((article) => {

                        if (article.id === articleId) {

                            if (article.bookmarkStatus === true) {

                                article.bookmarkStatus = false;

                            }

                        }

                    });

                });

            }

        });

        Mixpanel.send('ConnectWeb News Bookmark Click', {
            Bookmark: 'Unsave',
        });

    }

    /**
     * Get an article by id
     * Push it to repo
     * params @int
     */
    getSavedArticle(articleId) {

        _$http({

            method: 'GET',
            url: `${callUrl}/${articleId}`,

        }).then((response) => {

            _NewsRepository.addBookmark(response.data, lang);
            this.getShortDescriptionSingleArticle(response.data);

        });

    }

    /**
     * Get a list of articles
     * If article is not saved in repo
     */
    getSavedArticles() {

        const currentBookmarks = parsedBookmarks[lang];
        const repoBookmarks = _NewsRepository.getAllBookmarks();

        currentBookmarks.forEach((currentArticle) => {

            const found = repoBookmarks[lang].find(element => element.id === currentArticle);

            if (!found) {

                if (currentBookmarks.length > 0) {

                    _$http({

                        method: 'GET',
                        url: `${callUrl}/${currentArticle}`,

                    }).then((response) => {

                        _NewsRepository.replaceBookmarks(response.data, lang);
                        this.getShortDescriptionSingleArticle(response.data);

                    });

                }

            }

        });

    }

    /**
     * Check if any article status was changed
     * in listing or article view
     */
    checkBookmarksStatus() {

        const currentBookmarks = parsedBookmarks[lang];
        const repoBookmarks = _NewsRepository.getAllBookmarks();

        _$scope.news.forEach((item) => {

            if (item) {

                Object.keys(item).forEach((category) => {

                    item[category].forEach((article) => {

                        if (currentBookmarks.length === 0) {

                            article.bookmarkStatus = false;

                        } else {

                            currentBookmarks.forEach(() => {

                                const found = repoBookmarks[lang]
                                    .find(element => element.id === article.id);

                                if (found) {

                                    article.bookmarkStatus = true;

                                } else {

                                    article.bookmarkStatus = false;

                                }

                            });

                        }

                    });

                });

            }

        });

    }

    /**
     * Check if articles from page are loaded
     * Show or hide the loader
     * params @int
     */
    checkLoadingStatus(page) {

        if (!_$scope.news[parseInt(page, 0) - 1]) {

            _$scope.isLoading = true;

        } else {

            _$scope.isLoading = false;

        }

    }

    checkIfcategoryIsAvailable(categories, currentCategory, $state) {

        if (currentCategory !== 'bookmarks' && currentCategory !== 'threats-landscape') {

            if (!categories[currentCategory]) {

                $state.go('root.dashboard.news', {
                    tab: 'how-to',
                    page: '1',
                });

            }

        }

    }

    switchPage(pageIndex) {

        _$state.go('root.dashboard.news', {
            tab: _$scope.currentCategory,
            page: pageIndex,
        });

        Mixpanel.send('ConnectWeb News Page Click');

    }

    switchView(articleId, pageIndex) {

        _$state.go('root.dashboard.article', {
            tab: _$scope.currentCategory,
            id: articleId,
            page: pageIndex,
        });

        Mixpanel.send('ConnectWeb News Article Click');

    }

}

_serviceDependencies.push(News);

angular.module('controllers')
    .controller('News', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/controllers/dashboard/body/content/news/news.js